import React, { Component } from 'react';
import { connect } from 'react-redux';
import { signInUser } from '../../actions/authActions';


class Signin extends Component {

    state = {
        email:"",
        password:""
    }

    componentDidUpdate(props){
        if(this.props.authenticated!==props.authenticated){
            console.log('thi',this.props.authenticated, props.authenticated);
            props.history.push("/map");
        }  
     }

    emailChange(e){
        this.setState({email:e.target.value})
    }

    passwordChange(e){
        this.setState({password:e.target.value})
    }


    handleFormSubmit(e) {
        e.preventDefault();
        let email = this.state.email;
        let password = this.state.password;

        console.log('email',email,'  password',password);
        this.props.signInUser({email,password})
        
       
     }

    render(){
        return (
            <div className="limiter">
                <div className="container-login100">
                    <div className="wrap-login100 p-t-50 p-b-20">
                        <form className="login100-form validate-form" onSubmit={this.handleFormSubmit.bind(this)}>
                            <span className="login100-form-title p-b-70">
                                Welcome
                            </span>
                            <span className="login100-form-avatar">
                                <img src="../cropped-logo2.png" alt="AVATAR" />
                            </span>

                            <div className="wrap-input100 validate-input m-t-85 m-b-35" data-validate = "Enter username">
                                <input className="input100" type="text" name="email" placeholder="Email" 
                                        value={this.state.email} onChange={this.emailChange.bind(this)}/>
                                <span className="focus-input100" ></span>
                            </div>

                            <div className="wrap-input100 validate-input m-b-50" data-validate="Enter password">
                                <input className="input100" type="password" name="pass" placeholder="Password" 
                                        value={this.state.password} onChange={this.passwordChange.bind(this)} />
                                <span className="focus-input100"></span>
                            </div>

                            <div className="container-login100-form-btn">
                                <button className="login100-form-btn">
                                    Login
                                </button>
                            </div>

                            <ul className="login-more p-t-70">
                                <li className="m-b-8">
                                    <span className="txt1">
                                        Forgot
                                    </span>

                                    <a href="/" className="txt2">
                                        Username / Password?
                                    </a>
                                </li>

                                <li>
                                    <span className="txt1">
                                        Don’t have an account?
                                    </span>

                                    <a href="/" className="txt2">
                                        Sign up
                                    </a>
                                </li>
                            </ul>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    console.log('state',state);
    return {
        authenticated:  state.auth.authenticated,
        auth_error: state.auth.error
    }
}

export default connect(mapStateToProps, { signInUser })(Signin);


// WEBPACK FOOTER //
// ./src/v3/components/auth/signin.js